import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import usePersistedState from 'hooks/usePersistedState';
import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Snowfall from 'react-snowfall';
import { WL_CONFIG, IS_CHRISTMAS_TIME } from 'constants';
import SelectOrganization from './select-organization';
import {
  sidebar,
  sidebarItemsContainer,
  sidebarLogo,
  sidebarTopContainer,
  sidebarTrigger,
  sidebarTriggerIcon,
} from './styles';
import useSideBarItems from './useSideBarItems';
import './index.css';

function Sidebar({ collapsed, setCollapsed, style = {} }) {
  const { bottomItems, topItems } = useSideBarItems(collapsed);
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = usePersistedState(
    [],
    'sidebar/open-keys',
  );
  const [currentPath, setCurrentPath] = useState(
    location.pathname === '/' || location.pathname === ''
      ? '/console'
      : location.pathname.replace(/\/+$/, ''),
  );

  const handleGoHome = () => {
    navigate('/console');
  };

  const Logo = collapsed ? WL_CONFIG.logo.small : WL_CONFIG.logo.medium;
  const trigger = useMemo(() => {
    const Trigger = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined;
    return (
      <div
        className={`flex items-center justify-${collapsed ? 'center' : 'start'} h-full`}
        style={sidebarTrigger(collapsed)}
      >
        <Trigger style={sidebarTriggerIcon} />
      </div>
    );
  }, [collapsed]);

  const onSelectMenu = (e) => {
    setCurrentPath(e.key);
    navigate(e.key);
  };

  return (
    <Layout.Sider
      style={{ ...sidebar, ...style }}
      width={240}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      trigger={trigger}

    >
      <div className="flex flex-col justify-between" style={sidebarTopContainer}>
        <div>
          <div className="flex justify-start" style={{ ...sidebarLogo, position: 'relative' }}>
            {IS_CHRISTMAS_TIME && <Snowfall snowflakeCount={8} style={{ marginTop: -15 }} />}
            <Logo onClick={handleGoHome} style={{ width: collapsed ? 30 : 150 }} />
          </div>

          <SelectOrganization collapsed={collapsed} setCollapsed={setCollapsed} />
          <Menu
            style={{
              ...sidebarItemsContainer,
              maxHeight: 'calc(100vh - 280px)',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
            selectedKeys={[currentPath]}
            onClick={onSelectMenu}
            mode="inline"
            className={`top-sidebar-menu ${collapsed ? 'collapsed' : ''}`}
            openKeys={openKeys}
            onOpenChange={setOpenKeys}
            items={topItems}
          />
        </div>
        <Menu
          style={sidebarItemsContainer}
          defaultSelectedKeys={['']}
          selectedKeys={[currentPath]}
          mode="inline"
          onClick={onSelectMenu}
          className="bottom-sidebar-menu"
          items={bottomItems}
        />
      </div>
    </Layout.Sider>
  );
}

export default Sidebar;
